(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anh-portfolio-interactif"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('anh-gallery')) {
  customElements.define('anh-gallery', class extends HTMLElement {
    connectedCallback() {
      if(this.abort) return;
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.track=this.querySelector('.ag-track');
      this.cards=[...this.querySelectorAll('.ag-card')];
      this.dialog=this.querySelector('dialog');
      this.content=this.querySelector('.ag-content');
      this.index=0;
      this.addEventListener('click',e=>{
        const b=e.target.closest('button'); if(!b)return;
        if(b.matches('.ag-open')){this.opener=b;this.show(this.cards.indexOf(b.closest('.ag-card')));this.dialog.showModal();this.oldOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';}
        if(b.hasAttribute('data-close'))this.dialog.close();
        if(b.hasAttribute('data-prev'))this.show(this.index-1);
        if(b.hasAttribute('data-next'))this.show(this.index+1);
        if(b.hasAttribute('data-scroll')){const card=this.cards[0];if(card)this.track.scrollBy({left:Number(b.dataset.scroll)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
        if(b.matches('.ag-detail')){const img=this.content.querySelector('.ag-picture img');if(!b.dataset.original){b.dataset.original=img.src;b.dataset.originalAlt=img.alt;}const detail=b.dataset.active!=='true';img.removeAttribute('srcset');img.src=detail?b.dataset.image:b.dataset.original;img.alt=detail?b.dataset.alt:b.dataset.originalAlt;b.dataset.active=String(detail);b.textContent=detail?'Revenir à la vue générale ↗':'Voir le détail +';}
      },options);
      this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}},options);
      this.dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.oldOverflow||'';this.opener?.focus({preventScroll:true});},options);
      this.dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1));}},options);
      this.track.addEventListener('scroll',()=>this.update(),{...options,passive:true});
      this.observer=new ResizeObserver(()=>this.update());this.observer.observe(this.track);this.update();
    }
    show(i){if(i<0||i>=this.cards.length)return;this.index=i;this.content.replaceChildren(this.cards[i].querySelector('template').content.cloneNode(true));this.dialog.setAttribute('aria-label',this.content.querySelector('[data-title]').textContent);this.querySelector('.ag-count').textContent=String(i+1).padStart(2,'0')+' / '+String(this.cards.length).padStart(2,'0');this.querySelector('[data-prev]').disabled=i===0;this.querySelector('[data-next]').disabled=i===this.cards.length-1;this.dialog.scrollTop=0;}
    update(){const max=this.track.scrollWidth-this.track.clientWidth;this.querySelectorAll('[data-scroll]').forEach(b=>{b.hidden=max<3;b.disabled=Number(b.dataset.scroll)<0?this.track.scrollLeft<3:this.track.scrollLeft>max-3;});}
    disconnectedCallback(){if(this.dialog?.open){this.dialog.close();document.documentElement.style.overflow=this.oldOverflow||'';}this.abort?.abort();this.abort=null;this.observer?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
